import { googleProvider, microsoftProvider } from '@/lib/firebase';

import type { AuthProvider } from 'firebase/auth';

export type PopupProviderId = 'google' | 'microsoft';

export const POPUP_PROVIDERS: Record<PopupProviderId, AuthProvider> = {
  google: googleProvider,
  microsoft: microsoftProvider,
};

export const POPUP_PROVIDER_COPY = {
  google: {
    signIn: 'auth.signInWithGoogle',
    opening: 'auth.openingGoogle',
    error: 'auth.googleError',
  },
  microsoft: {
    signIn: 'auth.signInWithMicrosoft',
    opening: 'auth.openingMicrosoft',
    error: 'auth.microsoftError',
  },
} as const satisfies Record<PopupProviderId, { signIn: string; opening: string; error: string }>;

/**
 * Firebase allows one account per email, so a Microsoft sign-in for an email
 * that already signs in with Google (or a password) is refused with this code.
 */
export const ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL = 'auth/account-exists-with-different-credential';

const POPUP_DISMISSED_CODES: ReadonlySet<string> = new Set([
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
]);

/** The user closed the popup, or a newer popup replaced it — not a failure. */
export function isPopupDismissed(code: string | undefined): boolean {
  return code !== undefined && POPUP_DISMISSED_CODES.has(code);
}
